// extracted by mini-css-extract-plugin
export default {"list":"_5ozeyiFp4hJrDEQaLkFT"};